import MenuIcon from '@mui/icons-material/Menu';
import { AppBar, Avatar, Box, IconButton, Menu, MenuItem, Toolbar } from '@mui/material';
import { signOut } from 'firebase/auth';
import React from 'react';
import logo from '../assets/White logo - no background.png';
import { auth } from '../firebase';
import { useAuth } from '../hooks/useAuth';

interface AppHeaderProps {
	drawerWidth: number;
	onDrawerToggle: () => void;
}

const AppHeader = ({ drawerWidth, onDrawerToggle }: AppHeaderProps) => {
	const { user } = useAuth();
	const [menuAnchorEl, setMenuAnchorEl] = React.useState<null | HTMLElement>(null);

	const handleSignOut = async () => {
		try {
			await signOut(auth);
			setMenuAnchorEl(null);
		} catch (error) {
			console.error('Error signing out:', error);
		}
	};

	const handleMenuOpen = (event: React.MouseEvent<HTMLElement>) => {
		setMenuAnchorEl(event.currentTarget);
	};

	const handleMenuClose = () => {
		setMenuAnchorEl(null);
	};

	return (
		<AppBar
			position="fixed"
			sx={{
				zIndex: theme => theme.zIndex.drawer + 1,
				background: '#000',
				width: { sm: '100%' },
				ml: { sm: `${drawerWidth}px` },
			}}
			className="no-print"
		>
			<Toolbar>
				<IconButton
					color="inherit"
					aria-label="open drawer"
					edge="start"
					onClick={onDrawerToggle}
					sx={{ mr: 2, display: { sm: 'none' } }}
				>
					<MenuIcon />
				</IconButton>

				<Box sx={{ display: 'flex', alignItems: 'center', p: 2 }}>
					<img
						src={logo}
						alt="Aiyarise Logo"
						style={{ maxWidth: '160px', height: 'auto' }}
					/>
				</Box>

				{/* Spacer to push avatar to the right */}
				<Box sx={{ flexGrow: 1 }} />

				{/* Profile Avatar Menu or Logo Only */}
				{user && (
					<Box sx={{ display: 'flex', alignItems: 'center' }}>
						<IconButton
							size="large"
							color="inherit"
							aria-label="account menu"
							onClick={handleMenuOpen}
							sx={{ p: 1 }}
						>
							{user.photoURL ? (
								<Avatar src={user.photoURL} sx={{ width: 32, height: 32 }} />
							) : (
								<Avatar sx={{ width: 32, height: 32, bgcolor: 'primary.main' }}>
									{user.displayName
										? user.displayName[0].toUpperCase()
										: user.email
											? user.email[0].toUpperCase()
											: '?'}
								</Avatar>
							)}
						</IconButton>
						<Menu
							anchorEl={menuAnchorEl}
							open={Boolean(menuAnchorEl)}
							onClose={handleMenuClose}
							anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
							transformOrigin={{ vertical: 'top', horizontal: 'right' }}
							disableScrollLock
							sx={{ mt: 1.5 }}
						>
							<MenuItem disabled sx={{ opacity: 0.7 }}>
								{user.displayName || user.email}
							</MenuItem>
							<MenuItem onClick={handleSignOut}>Logout</MenuItem>
						</Menu>
					</Box>
				)}
			</Toolbar>
		</AppBar>
	);
};

export { AppHeader };
